module.exports = __webpack_public_path__ + "static/media/csulb-logo.f368850d.png";